import KLink from "./KLink";
import getMapLink from "@/utils/maps/get-link";
import { formatLocation } from "kinnect-formatters";

export default {
	name: "KMapLink",

	props: {
		address: String,
		city: String,
		format: {
			default: "a, c, s z",
			type: String
		},
		icon: {
			default: "place",
			type: String
		},
		latitude: Number,
		longitude: Number,
		state: String,
		zip: String
	},


	computed: {
		formattedLocationString() {
			return formatLocation(
				{
					address: this.address,
					city: this.city,
					state: this.state,
					zip: this.zip
				},
				this.format
			);
		},

		mapLink() {
			return getMapLink( {
				address: this.address,
				city: this.city,
				latitude: this.latitude,
				longitude: this.longitude,
				state: this.state,
				zip: this.zip
			} );
		}
	},

	render() {
		return <KLink
			href={this.mapLink}
			icon={this.icon}
			target="_blank"
		>
			{this.formattedLocationString}
		</KLink>;
	}
};
